import axios from 'axios';
import * as Config from '../../config';

const state = {};

const actions = {
    afip_get_status_facturacion() {
        return new Promise((resolve, reject) => {
            axios.get(Config.apiPath + 'afip/get-status-facturacion')
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    afip_get_consulta_padron({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'afip/get-consulta-padron', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    afip_get_recategorizacion({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios.post(Config.apiPath + 'afip/get-recategorizacion', form)
                .then(
                    response => {
                        resolve(response.data);
                    })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    afip_get_constancia({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'afip/get-constancia?cuit=' + form.cuit, {
                    responseType: 'blob' // Indicamos que esperamos una respuesta binaria
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    afip_get_form_184({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .get(Config.apiPath + 'afip/get-form-184?cuit=' + form.cuit, {
                    responseType: 'blob' // Indicamos que esperamos una respuesta binaria
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
    afip_verifyLogin({ commit, dispatch }, form) {
        return new Promise((resolve, reject) => {
            axios
                .post(Config.apiPath + 'afip/verify-login', form)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    reject(error.response);
                });
        });
    },
}

const mutations = {

};

export default {
    state,
    actions,
    mutations
};